<div class="flex flex-col w-full bg-white">
  <!-- Header -->
  <div class="flex items-center justify-between px-2 pt-2 pb-2 border-b border-border">
    <div class="flex items-center gap-2">
      <mat-icon
        class="icon-size-6 text-text-default"
        svgIcon="heroicons_solid:map-pin"
      ></mat-icon>
      <h2 class="m-0 text-text-default font-bold text-xl leading-normal">{{ 'Checkin' | transloco }}</h2>
    </div>
    <button
      mat-icon-button
      (click)="onClose()"
      class="close-button"
    >
      <mat-icon
        class="icon-size-6 text-text-default"
        svgIcon="heroicons_outline:x-mark"
      ></mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="px-2 py-2 text-default">
    <form
      [formGroup]="form"
      class="flex flex-col space-y-4"
    >
      <p class="text-base">{{ 'Deseja selecionar sua localização?' | transloco }}</p>

      <svc-select
        class="w-full"
        [label]="{ text: ('Lugar' | transloco) }"
        formControlName="placeId"
        [options]="places"
        [loading]="isLoadingPlaces"
      ></svc-select>

      <svc-select
        class="w-full"
        [label]="{ text: ('Equipamento' | transloco) }"
        [placeholder]="'Opcional' | transloco"
        formControlName="equipmentId"
        [options]="equipments"
        [loading]="isLoadingEquipments"
        [disabled]="!form.get('placeId')?.value"
        [hideOptionsWhenSelected]="false"
      ></svc-select>

      <svc-slide-toggle
        class="text-default flex items-center gap-2"
        formControlName="dontAskAgain"
      >
        {{ 'N\u00E3o perguntar novamente' | transloco }}
      </svc-slide-toggle>
    </form>
  </div>

  <!-- Footer -->
  <div class="mt-[8.5px] border-t border-border"></div>
  <div class="flex items-center justify-end gap-2 px-2 py-2">
    <svc-button-neutral
      [label]="'Fechar' | transloco"
      type="button"
      (click)="onClose()"
    ></svc-button-neutral>
    <svc-button-confirm
      [label]="'Confirmar' | transloco"
      type="button"
      (click)="onConfirm()"
    ></svc-button-confirm>
  </div>
</div>
